export default {
    title: '模板库',
    createTemplate: '创建模板',
    searchPlaceholder: '搜索模板...',
    showingResults: '显示 {count} 个结果',
    total: '共',
    sort: '排序',

    // Tabs
    all: '全部',
    myTemplates: '我的模板',
    sharedTemplates: '分享的模板',
    favorites: '收藏',
    allRegions: '全部地区',

    // Sorting
    sortByUpdated: '最近更新',
    sortByCreated: '最近创建',
    sortByNameAsc: '名称 (A-Z)',
    sortByNameDesc: '名称 (Z-A)',

    // Types
    types: {
        PATENT_APPLICATION: '专利申请',
        INVENTION_DISCLOSURE: '发明披露',
        OFFICE_ACTION_RESPONSE: '审查意见答复',
    },

    // Regions
    regions: {
        all: '全部地区',
        USPTO: '美国专利局',
        EPO: '欧洲专利局',
        PCT: 'PCT国际申请',
        CNIPA: '中国专利局',
        JPO: '日本专利局',
        KIPO: '韩国专利局',
    },

    // Technology areas
    technologyArea: {
        general: '通用',
        electrical: '电气',
        mechanical: '机械',
        chemical: '化学',
        software: '软件',
        biotech: '生物技术',
    },

    // Actions
    preview: '预览',
    edit: '编辑',
    editInfo: '编辑信息',
    editContent: '编辑内容',
    duplicate: '复制',
    delete: '删除',
    favorite: '收藏',
    unfavorite: '取消收藏',
    setDefault: '设为默认',
    unsetDefault: '取消默认',
    defaultTemplate: '默认模版',
    moreActions: '更多操作',
    share: '分享',
    shareTemplate: '分享',

    // Sources
    source: '来源',
    system: '系统',
    custom: '自定义',
    systemTemplate: '系统模板',

    // Table columns
    name: '名称',
    type: '类型',
    region: '地区',
    updated: '更新时间',
    actions: '操作',

    // Messages
    messages: {
        fetchListFailed: '获取模板列表失败',
        fetchDetailFailed: '获取模板详情失败',
        createSuccess: '模板创建成功',
        createFailed: '模板创建失败',
        updateSuccess: '模板更新成功',
        updateFailed: '模板更新失败',
        deleteSuccess: '模板删除成功',
        deleteFailed: '模板删除失败',
        duplicateSuccess: '模板复制成功',
        duplicateFailed: '模板复制失败',
        favoriteSuccess: '收藏成功',
        favoriteFailed: '收藏失败',
        unfavoriteSuccess: '取消收藏成功',
        unfavoriteFailed: '取消收藏失败',
        setDefaultSuccess: '设置默认模版成功',
        setDefaultFailed: '设置默认模版失败',
        unsetDefaultSuccess: '取消默认模版成功',
        unsetDefaultFailed: '取消默认模版失败',
        systemTemplateReadOnly: '系统模板为只读，无法编辑',
        shareSuccess: '分享成功',
        shareFailed: '分享失败',
        deleteShareSuccess: '删除分享成功',
        deleteShareFailed: '删除分享失败',
        updateShareSuccess: '更新分享成功',
        updateShareFailed: '更新分享失败',
    },

    // Share Dialog
    shareDialog: {
        title: '分享模板',
        shareSettings: '分享设置',
        shareType: '分享类型',
        companyShare: '公司',
        companyShareName: '本公司',
        personalShare: '个人',
        companyShareDesc: '分享给公司内所有成员',
        personalShareDesc: '分享给指定用户',
        selectUser: '选择用户',
        searchUser: '搜索用户',
        permission: '权限',
        readOnly: '只读',
        editable: '可编辑',
        expiresAt: '过期时间',
        neverExpires: '永久',
        expiry7Days: '7天',
        expiry15Days: '15天',
        expiry30Days: '30天',
        setExpireTime: '设置过期时间',
        sharedBy: '分享人',
        sharedTo: '分享给',
        sharedAt: '分享时间',
        shareList: '分享列表',
        noShares: '暂无分享记录',
        createShare: '创建分享',
        deleteShareConfirm: '确定要删除此分享吗？',
        cancel: '取消',
        confirm: '确定',
        save: '保存',
    },

    // Empty states
    noTemplates: '暂无模板',
    noTemplatesDesc: '创建您的第一个模板开始使用',
    noResults: '未找到匹配的模板',
    noResultsDesc: '尝试调整搜索条件或筛选器',

    // Dialog
    dialog: {
        createTemplate: '创建模板',
        createTemplateDesc: '选择类型并设置名称，开始创建专业模板',
        templateName: '模板名称',
        templateNamePlaceholder: '请输入模板名称',
        templateType: '模板类型',
        creationMethod: '创建方式',
        recommended: '推荐',
        blankTemplate: '空白模板',
        blankTemplateDesc: '从零开始创建全新模板',
        copyFromExisting: '复制模板',
        copyFromExistingDesc: '基于现有模板创建',
        selectBaseTemplate: '选择基础模板',
        noTemplatesAvailable: '暂无可用模板',
        createAndEdit: '创建并编辑',
        sections: '模板章节',
        cancel: '取消',
        unsavedChangesTitle: '未保存的修改',
        unsavedChangesMessage: '您有未保存的修改，确定要关闭吗？关闭后修改将丢失。',
        discardChanges: '放弃修改',
        continueEditing: '继续编辑',
        lastUpdated: '最后更新',
        noContent: '暂无内容',
        // Level selection (Super Admin only)
        level: '可见性',
        adminOnly: '仅管理员',
        systemLevel: '系统级',
        userLevel: '用户级',
        systemLevelDesc: '对所有用户可见',
        userLevelDesc: '仅自己可见',
        // Description
        description: '描述',
        descriptionPlaceholder: '简要描述此模板的用途和使用场景...',
        optional: '可选',
        // Word import
        importFromWord: '从 Word 导入',
        importFromWordDesc: '从 .docx 文件提取章节',
        uploadWordFile: '上传 Word 文档',
        uploadWordAction: '拖放 .docx 文件到此处或点击上传',
        uploadWordHint: '支持包含标题样式的 .docx 文件',
        parsing: '正在解析文档...',
        parseSuccess: '成功解析 {count} 个章节',
        parseFailed: '解析文档失败',
        parsedSections: '已解析章节 ({count})',
    },

    // Template Editor
    templateEditor: {
        back: '返回',
        untitledTemplate: '未命名模板',
        clickToEdit: '点击编辑',
        templateType: '模板类型',
        region: '地区',
        technologyArea: '技术领域',
        from: '来源',
        visibility: '可见性',
        private: '私有',
        library: '模板库',
        saveTemplate: '保存模板',
        aiInstructions: 'AI 指令',
        aiInstructionsDesc: '为每个章节设置 AI 指令，引导 AI 按要求生成符合预期的内容。',
        addSection: '添加章节',
        sectionTitle: '章节标题',
        insert: '插入',
        delete: '删除',
        selectInstruction: '选择指令',
        aiInstructionPlaceholder: '输入此章节的 AI 指令...',
        description: '描述',
        descriptionPlaceholder: '描述模板的用途和主要特点...',
        // Level
        level: '可见性',
        // Collapse/Expand buttons
        collapseAll: '全部收起',
        expandAll: '全部展开',
        // Section prompt editor
        aiInstruction: 'AI 指令',
        words: '字',
        fromLibrary: '从库中选择',
        remove: '删除',
        required: '必填',
        // Section names
        sections: {
            title: '标题',
            crossReference: '相关申请交叉引用',
            fieldOfInvention: '发明领域',
            background: '背景技术',
            summary: '发明内容',
            briefDescription: '附图说明',
            detailedDescription: '具体实施方式',
            claims: '权利要求',
            abstract: '摘要',
            newSection: '新章节',
        },
        types: {
            patentApplication: '专利申请',
            inventionDisclosure: '发明交底书',
            officeActionResponse: '审查意见答复',
        },
        messages: {
            nameRequired: '请输入模板名称',
            updateSuccess: '模板更新成功',
            saveSuccess: '模板保存成功',
            saveFailed: '保存模板失败',
            loadFailed: '加载模板失败',
            insertedPlaceholder: '已插入 [{title}]',
            readOnlyPermission: '权限不足：您只有只读权限',
        },
        systemTemplate: '系统模板',
        systemTemplateReadOnly: '系统模板为只读模式',
        readOnly: '只读',
        clickToEditName: '点击标题修改',
    },
};
